import React from 'react';

import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { useQueryState, useRouter } from '@cvt/routing';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { AuthContext } from '../contexts/AuthContext';


export const Impersonate: React.FC = () => {
  const router = useRouter();
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback } = React.useContext(FeedbackContext);
  const { impersonate } = React.useContext(AuthContext);

  const [token] = useQueryState('token');

  const impersonateUser = React.useCallback(async (token: string) => {
    try {
      await impersonate(token);
      router.home.go();
    } catch {
      triggerFeedback({
        severity: 'error',
        message: dictionary.auth.impersonate.invalidToken,
      });
      router.auth.login.go();
    }
  }, [impersonate, router, triggerFeedback, dictionary.auth.impersonate.invalidToken]);

  React.useEffect(() => {
    if (token) {
      impersonateUser(token);
    } else {
      triggerFeedback({
        severity: 'error',
        message: dictionary.auth.impersonate.noToken,
      });
      router.auth.login.go();
    }
  }, [impersonateUser, token, triggerFeedback, dictionary, router]);

  return <BodyLoading height="100vh"/>;
};
